<template>
  <div v-if="accordians" class="buybox__accors">
    <div class="accors__container">
      <div v-for="(items, key) in accordians" :key="key" :class="['accor__item', {'active': isOpen(key)}]">
        <div class="accor__title" @click="toggleAccordion(key)">
          <span class="text-xl">{{ key }}</span>
          <svg class="accor__title-icon">
            <use href="#arrow"></use>
          </svg>
        </div>
        <transition v-if="!isMobile" name="accor-slide">
          <div class="accor__content">
            <div v-if="Array.isArray(items)" class="accor__items-inner">
              <div v-for="(item, index) in items" :key="index" class="accor__item-inner">
                <ImageField v-if="item.image" :key="item.image" class="accor__item-inner-image" :obj="{'url':item.image,'alt':'Image','width':660,'height':660}" width-param="width" sizes="660px"/>
                <div v-html="item.content"></div>
              </div>
            </div>
            <div v-else v-html="items.content"></div>
          </div>
        </transition>
      </div>
    </div>

    <transition name="drawer-slide">
      <div v-if="isMobile && drawerOpen" class="buybox__accors-drawer">
        <div class="buybox__accors-drawer--overlay" @click="toggleAccordion(false)"></div>
        <div class="buybox__accors-drawer-content">
          <div v-for="(items, key) in accordians" :key="key" class="buybox__accors-drawer-item">
            <div v-show="isOpen(key)">
              <div class="buybox__accors-drawer-title" @click="toggleAccordion(key)">
                <span class="text-lg">{{ key }}</span>
                <svg class="buybox__accors-drawer-close">
                  <use href="#exit"></use>
                </svg>
              </div>
              <div class="accor__content">
                <div v-if="Array.isArray(items)" class="accor__items-inner">
                  <div v-for="(item, index) in items" :key="index" class="accor__item-inner">
                    <ImageField v-if="item.image" :key="item.image" class="accor__item-inner-image" :obj="{'url':item.image,'alt':'Image','width':660,'height':660}" width-param="width" sizes="660px"/>
                    <div v-html="item.content"></div>
                  </div>
                </div>
                <div v-else v-html="items.content"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
  import { ref, computed } from 'vue';
  import ImageField from "../../global/image.vue";
  import windowResize from '../../../utils/window-resize';

  const props = defineProps({
    accordians: {
      type: Object,
      default: () => ({})
    }
  })
  
  const { windowWidth } = windowResize()
  const activeAccordion = ref(null);
  const drawerOpen = ref(false);

  const isMobile = computed(() => {
    return windowWidth.value < 1024;
  })

  const isOpen = (key) => {
    return activeAccordion.value === key;
  }

  const toggleAccordion = (key) => {
    if (key === false) {
      drawerOpen.value = false;
      activeAccordion.value = null;
      document.body.style.overflow = 'auto';
    } else {
      const isAccordionOpen = activeAccordion.value === key;
      activeAccordion.value = isAccordionOpen ? null : key;
      drawerOpen.value = isMobile.value && activeAccordion.value !== null;

      document.body.style.overflow = isMobile.value && drawerOpen.value ? 'hidden' : 'auto';
    }
  };

</script>